var g = Object.defineProperty;
var u = (e, M, t) => M in e ? g(e, M, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[M] = t;
var N = (e, M, t) => (u(e, typeof M != "symbol" ? M + "" : M, t), t);
import { constants as n } from "starknet";
import { C as j, a, b as s, U as D, d as r } from "./connector-ca2f4153.js";
const T = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iOCIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjQwMTggNy41NTU1NkgxMy41OTgyQzEzLjQzNzcgNy41NTU1NiAxMy4zMDkxIDcuNjg3NDcgMTMuMzA1NiA3Ljg1MTQzQzEzLjIwODUgMTIuNDYwMyAxMC44NDg0IDE2LjgzNDcgNi43ODYwOCAxOS45MzMxQzYuNjU3MTEgMjAuMDMxNCA2LjYyNzczIDIwLjIxNjIgNi43MjIwMiAyMC4zNDkzTDkuNTMyNTMgMjQuMzE5NkM5LjYyODE1IDI0LjQ1NDggOS44MTQ0NCAyNC40ODUzIDkuOTQ1NTggMjQuMzg2QzEyLjQ4NTYgMjIuNDYxMyAxNC41Mjg3IDIwLjEzOTUgMTYgMTcuNTY2QzE3LjQ3MTMgMjAuMTM5NSAxOS41MTQ1IDIyLjQ2MTMgMjIuMDU0NSAyNC4zODZDMjIuMTg1NiAyNC40ODUzIDIyLjM3MTkgMjQuNDU0OCAyMi40Njc2IDI0LjMxOTZMMjUuMjc4MSAyMC4zNDkzQzI1LjM3MjMgMjAuMjE2MiAyNS4zNDI5IDIwLjAzMTQgMjUuMjE0IDE5LjkzMzFDMjEuMTUxNiAxNi44MzQ3IDE4Ljc5MTUgMTIuNDYwMyAxOC42OTQ2IDcuODUxNDNDMTguNjkxMSA3LjY4NzQ3IDE4LjU2MjMgNy41NTU1NiAxOC40MDE4IDcuNTU1NTZaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjQuNzIzNiAxMC40OTJMMjQuMjIzMSA4LjkyNDM5QzI0LjEyMTMgOC42MDYxNCAyMy44NzM0IDguMzU4MjQgMjMuNTU3NyA4LjI2MDIzTDIyLjAwMzkgNy43NzU5NUMyMS43ODk1IDcuNzA5MDYgMjEuNzg3MyA3LjQwMTc3IDIyLjAwMTEgNy4zMzIwMUwyMy41NDY5IDYuODI0NjZDMjMuODYwOSA2LjcyMTQ2IDI0LjEwNiA2LjQ2OTUyIDI0LjIwMjcgNi4xNTAxMUwyNC42Nzk4IDQuNTc1MDJDMjQuNzQ1OCA0LjM1NzA5IDI1LjA0ODkgNC4zNTQ3NyAyNS4xMTgzIDQuNTcxNTZMMjUuNjE4OCA2LjEzOTE1QzI1LjcyMDYgNi40NTc0IDI1Ljk2ODYgNi43MDUzMSAyNi4yODQyIDYuODAzOUwyNy44MzggNy4yODc2MUMyOC4wNTI0IDcuMzU0NSAyOC4wNTQ3IDcuNjYxNzkgMjcuODQwOCA3LjczMjEzTDI2LjI5NSA4LjIzOTQ4QzI1Ljk4MTEgOC4zNDIxIDI1LjczNiA4LjU5NDA0IDI1LjYzOTMgOC45MTQwMkwyNS4xNjIxIDEwLjQ4ODVDMjUuMDk2MSAxMC43MDY1IDI0Ljc5MyAxMC43MDg4IDI0LjcyMzYgMTAuNDkyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==", o = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZT0iYmxhY2siPgogIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuODc5IDcuNTE5YzEuMTcxLTEuMDI1IDMuMDcxLTEuMDI1IDQuMjQyIDAgMS4xNzIgMS4wMjUgMS4xNzIgMi42ODcgMCAzLjcxMi0uMjAzLjE3OS0uNDMuMzI2LS42Ny40NDItLjc0NS4zNjEtMS40NS45OTktMS40NSAxLjgyN3YuNzVNMjEgMTJhOSA5IDAgMTEtMTggMCA5IDkgMCAwMTE4IDB6bS05IDUuMjVoLjAwOHYuMDA4SDEydi0uMDA4eiIgLz4KPC9zdmc+", l = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZT0id2hpdGUiPgogIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuODc5IDcuNTE5YzEuMTcxLTEuMDI1IDMuMDcxLTEuMDI1IDQuMjQyIDAgMS4xNzIgMS4wMjUgMS4xNzIgMi42ODcgMCAzLjcxMi0uMjAzLjE3OS0uNDMuMzI2LS42Ny40NDItLjc0NS4zNjEtMS40NS45OTktMS40NSAxLjgyN3YuNzVNMjEgMTJhOSA5IDAgMTEtMTggMCA5IDkgMCAwMTE4IDB6bS05IDUuMjVoLjAwOHYuMDA4SDEydi0uMDA4eiIgLz4KPC9zdmc+Cg==";
class d extends j {
  constructor({ options: t }) {
    super();
    N(this, "_wallet");
    N(this, "_options");
    this._options = t;
  }
  available() {
    return this.ensureWallet(), this._wallet !== void 0;
  }
  async ready() {
    return this.ensureWallet(), this._wallet ? await this._wallet.isPreauthorized() : !1;
  }
  async chainId() {
    if (this.ensureWallet(), !this._wallet)
      throw new a();
    const t = await this._wallet.provider.getChainId();
    return BigInt(t);
  }
  async onAccountsChanged(t) {
    let i;
    if (typeof t == "string" ? i = t : i = t[0], i) {
      const I = await this.chainId();
      this.emit("change", { account: i, chainId: I });
    } else
      this.emit("disconnect");
  }
  onNetworkChanged(t) {
    switch (t) {
      case "SN_MAIN":
        this.emit("change", {
          chainId: BigInt(n.StarknetChainId.SN_MAIN)
        });
        break;
      case "SN_GOERLI":
        this.emit("change", {
          chainId: BigInt(n.StarknetChainId.SN_GOERLI)
        });
        break;
      case "mainnet-alpha":
        this.emit("change", {
          chainId: BigInt(n.StarknetChainId.SN_MAIN)
        });
        break;
      case "goerli-alpha":
        this.emit("change", {
          chainId: BigInt(n.StarknetChainId.SN_GOERLI)
        });
        break;
      default:
        this.emit("change", {});
        break;
    }
  }
  async connect() {
    if (this.ensureWallet(), !this._wallet)
      throw new s();
    let t;
    try {
      t = await this._wallet.enable({ starknetVersion: "v5" });
    } catch {
      throw new D();
    }
    if (!this._wallet.isConnected || !t)
      throw new D();
    this._wallet.on("accountsChanged", async (c) => {
      await this.onAccountsChanged(c);
    }), this._wallet.on("networkChanged", (c) => {
      this.onNetworkChanged(c);
    }), await this.onAccountsChanged(t);
    const i = this._wallet.account.address, I = await this.chainId();
    return this.emit("connect", { account: i, chainId: I }), {
      account: i,
      chainId: I
    };
  }
  async disconnect() {
    if (this.ensureWallet(), !this.available())
      throw new s();
    if (!this._wallet?.isConnected)
      throw new r();
  }
  async account() {
    if (this.ensureWallet(), !this._wallet || !this._wallet.account)
      throw new a();
    return this._wallet.account;
  }
  get id() {
    return this._options.id;
  }
  get name() {
    if (!this._wallet)
      throw new a();
    return this._wallet.name;
  }
  get icon() {
    return this._options.icon ? this._options.icon : this._wallet?.icon ? {
      dark: this._wallet.icon,
      light: this._wallet.icon
    } : {
      dark: l,
      light: o
    };
  }
  get wallet() {
    if (!this._wallet)
      throw new a();
    return this._wallet;
  }
  ensureWallet() {
    const i = h(globalThis).filter((I) => I.id === this._options.id)[0];
    i && (this._wallet = i);
  }
}
function h(e) {
  return Object.values(
    Object.getOwnPropertyNames(e).reduce((M, t) => {
      if (t.startsWith("starknet")) {
        const i = e[t];
        z(i) && !M[i.id] && (M[i.id] = i);
      }
      return M;
    }, {})
  );
}
function z(e) {
  try {
    return e && [
      // wallet's must have methods/members, see IStarknetWindowObject
      "request",
      "isConnected",
      "provider",
      "enable",
      "isPreauthorized",
      "on",
      "off",
      "version",
      "id",
      "name",
      "icon"
    ].every((M) => M in e);
  } catch {
  }
  return !1;
}
export {
  T as A,
  d as I
};
